<template>
  <div class="warehouse-profile-page warehouse-profile-page--detail">

    <div class="warehouse-page-heading">
      <div class="warehouse-page-heading__icon" aria-hidden="true"><i class="fas fa-warehouse"></i></div>
      <div><span>Manajemen inventori</span><h1>Detail gudang</h1><p>Informasi lokasi penyimpanan dan daftar rak yang tersedia.</p></div>
    </div>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <Card :card-class="'warehouse-profile-card'">
          <template v-slot:body>
            <div class="warehouse-detail">
              <section class="warehouse-detail__information">
                <div class="warehouse-section-heading">
                  <div class="warehouse-section-heading__icon"><i class="fas fa-boxes"></i></div>
                  <div><span>Informasi gudang</span><h2>{{ data.name || 'Nama gudang belum tersedia' }}</h2><p>Data utama lokasi penyimpanan inventori.</p></div>
                </div>
                <dl class="warehouse-detail__grid">
                  <div><dt><i class="fas fa-warehouse"></i> Nama gudang</dt><dd>{{ displayValue(data.name) }}</dd></div>
                  <div><dt><i class="fas fa-map-marker-alt"></i> Alamat</dt><dd>{{ displayValue(data.address) }}</dd></div>
                  <div class="warehouse-detail__wide"><dt><i class="fas fa-align-left"></i> Keterangan</dt><dd>{{ displayValue(data.description) }}</dd></div>
                </dl>

                <div class="warehouse-detail__actions">
                <button @click="$router.push('/masters/warehouses/list')" class="btn btn-outline-primary"><i class="fas fa-arrow-left mr-2"></i>Kembali</button>
                <button
                  @click="$router.push({path: '/masters/warehouses/edit/' + data.id})"
                  v-if="btn"
                  class="btn btn-primary"
                ><i class="far fa-fw fa-edit"></i> Edit</button>
                <button
                  @click="deleteData"
                  class="btn btn-light-danger"
                  v-if="btn"
                ><i class="far fa-fw fa-trash-alt"></i> Hapus</button>
                </div>
              </section>

              <aside class="warehouse-detail__racks">
                <div class="warehouse-detail__racks-heading">
                  <div><span>Lokasi penyimpanan</span><h3>Daftar rak</h3></div>
                  <strong>{{ dataRack.length }}</strong>
                </div>
                <div class="warehouse-detail__table">
                      <b-table
                        striped
                        hover
                        responsive
                        class="mt-3"
                        :items="dataRack"
                        :fields="fields"
                      >
                        <template #table-colgroup="scope">
                          <col
                            v-for="field in scope.fields"
                            :key="field.key"
                            :style="{ width: field.key === 'actions' ? '20%' : '' }"
                          />
                        </template>
                      </b-table>
                      <b-pagination
                        v-if="dataRack.length != 0"
                        v-model="currentPage"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        @page-click="pageOnClick"
                        class="mt-4"
                      ></b-pagination>
                </div>
              </aside>
            </div>
          </template>
        </Card>
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import module from '@/core/modules/CrudModule.js'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      // Data
      data: {
        name: "",
        description: ""
      },
      dataRack:[],
      // Other
      imgLoaded: false,
      // user access
      btn: false,
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
      ],

      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
    }
  },

  components: {
    Card,
  },

  methods: {
    displayValue(value) {
      return value || '—'
    },

    onImageLoad() {
      this.imgLoaded = true
    },

    pageOnClick(evt, page) {
      evt.preventDefault()
      this.currentPage = page
      this.getRack()
    },

    async deleteData() {
      let result = await module.delete('warehouses/' + this.$route.params.id)
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push('/masters/warehouses/list')
      }
    },

    async get() {
      this.data = await module.get('warehouses/' + this.$route.params.id)
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push('/masters/warehouses/list')
      }
    },
    
    async getRack() {
      this.dataRack = await module.get('warehouses-rack/' + this.$route.params.id)
    },

    setActiveButton(){
      let access_right_user = window.localStorage.getItem("access_right_display")
      let access_right = JSON.parse(access_right_user)

      let a
      for(a = 0; a < access_right.length; a++){
        if(access_right[a] == "1802"){
          this.btn = true
        }
      }
    },

  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Gudang", route: "" },
      { title: "Daftar Gudang", route: "/masters/warehouses/list" },
      { title: "Detail" },
    ])
    // Get Data
    this.get()
    this.getRack()
    this.setActiveButton()
  },
}

</script>
<style lang="scss" src="@/assets/sass/pages/_warehouse-profile-pages.scss"></style>
